import React from 'react';
import PropTypes from 'prop-types';
import { Field as FormikField } from 'formik';

import ErrorIcon from '../../../../assets/images/icon_error_messages.gif';
import { Wrapper } from '../../css';

const Field = ({
  name,
  type,
  label,
  placeholder,
  disabled,
  required,
  list,
  errors,
  touched,
  onChange,
  style,
  comment
}) => {
  const fieldParams = {
    name,
    placeholder,
    disabled,
    className: 'select-style'
  };
  if (list) {
    fieldParams.as = 'select';
  } else {
    fieldParams.type = type;
  }
  if (onChange) fieldParams.onChange = onChange;
  if (style) fieldParams.style = style;

  return (
    <>
      <div className="main-content-form-headers">
        <span className="select-placeholder">
          {required ? `${label}*` : label}
        </span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors[name] && touched[name] ? 'error' : ''
        }`}
      >
        {list ? (
          <FormikField {...fieldParams}>
            {list &&
              list.map(item => {
                return (
                  <option key={item.text} value={item.value}>
                    {item.text}
                  </option>
                );
              })}
          </FormikField>
        ) : (
          <FormikField {...fieldParams} />
        )}
        <div className="error_messages">
          <span className="frg-body-font-14px">{errors[name]}</span>
        </div>
        <div id={`${name}_error_icon`} className="error_messages_icon">
          <img src={ErrorIcon} alt="error_icon" />
        </div>
      </div>
      {comment && (
        <Wrapper>
          <span className="frg-body-font-14px">{comment}</span>
        </Wrapper>
      )}
    </>
  );
};

Field.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
      text: PropTypes.string.isRequired
    })
  ),
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  onChange: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.any),
  comment: PropTypes.string
};

Field.defaultProps = {
  type: 'text',
  placeholder: '',
  disabled: false,
  required: false,
  list: null,
  onChange: null,
  style: null,
  comment: null
};

export default Field;
